import { Box, Text, VStack } from '@chakra-ui/react';

import TextWithTooltip from '../../../../components/TextWithTooltip';
import InfoPopoverIcon from './InfoPopoverIcon';

const SECTIONS = [
  {
    heading: 'What a payoff is',
    body: 'Your payoff is the price to buy your car from your lender today and own it outright. Paying it ends your lease.',
  },
  {
    heading: "What's in it",
    body: 'When you signed your lease, it set a price to buy the car at the end of your term. That number is printed on your lease agreement. Your payoff today is that price, plus the monthly payments you still owe, plus any fee your lender charges to end the lease early. That is why it is higher than the number on your lease.',
  },
  {
    heading: 'Why it changes',
    body: 'Every payment you make lowers it. Your lender tells us the date the number is good through. After that, we pull a fresh one.',
  },
  {
    heading: 'Why it matters when you sell',
    body: 'The buyer pays your lender first. If the offer is higher than your payoff, the difference goes to you. If it is lower, you pay the difference to sell.',
  },
];

const PayoffTooltipCopy = () => (
  <VStack spacing="10px" align="stretch" textAlign="left">
    {SECTIONS.map((section) => (
      <Box key={section.heading}>
        <Text fontWeight="700">{section.heading}</Text>
        <Text>{section.body}</Text>
      </Box>
    ))}
  </VStack>
);

const WIDTH_PROPS = { maxW: { base: 'calc(100vw - 32px)', md: '440px' }, w: 'max-content' };

export const PayoffTerm = () => (
  <TextWithTooltip
    label={<PayoffTooltipCopy />}
    popoverBodyProps={{ maxW: 'none' }}
    popoverContentProps={WIDTH_PROPS}
    textProps={{ color: 'inherit', fontSize: 'inherit' }}
  >
    payoff
  </TextWithTooltip>
);

export const PayoffTooltipIcon = (props: { color?: string; boxSize?: string }) => (
  <InfoPopoverIcon
    label={<PayoffTooltipCopy />}
    popoverContentProps={WIDTH_PROPS}
    ariaLabel="About your payoff"
    {...props}
  />
);

export default PayoffTooltipCopy;
